export default __webpack_public_path__ + "static/media/gallery_05.26861909.jpg";